import { render } from "./SuccessModal.vue?vue&type=template&id=0c6f415a&scoped=true&ts=true"
import script from "./SuccessModal.vue?vue&type=script&lang=ts"
export * from "./SuccessModal.vue?vue&type=script&lang=ts"

import "./SuccessModal.vue?vue&type=style&index=0&id=0c6f415a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c6f415a"]])

export default __exports__